<router-outlet />
<app-spinner />
<app-toaster />
<app-update-notice />